<script lang="ts">
  import Meta from "$lib/components/meta/MetaContribution.svelte";
  import Dialog from "$components/modals/Dialog.svelte";
  import { results } from "$components/episodes/gallery_store";
  import { episodeDate } from "$lib/dates";
  import { dev } from "$app/environment";
  import { onMount, onDestroy } from "svelte";
  import { modalActive } from "$lib/data.js";

  export let data;
  if (dev) console.log(data);

  let mounted = true;

  onMount(() => {
    $modalActive = true;
    mounted = true;
  });

  onDestroy(() => {
    $modalActive = false;
    mounted = false;
  });
</script>

{#if (data.totalGallery || $results) && data.episode.date && mounted && $modalActive}
  <Dialog
    gallery={$results.length > 0 ? $results : data.totalGallery}
    title="Episode #{data.episode.episode_number} Gallery"
    subtitle={episodeDate(data.episode.date)}
    discussions={data.discussions}
    enable_discussions
  ></Dialog>
{/if}

{#key data.id}
  <Meta
    episode={data.episode}
    contribution={data.additional_data}
    id={data.id}
    is_discussion={data.is_discussion}
  />
{/key}
